import { render, staticRenderFns } from "./AvatarUser.vue?vue&type=template&id=af36e7a4&scoped=true&"
import script from "./AvatarUser.vue?vue&type=script&lang=js&"
export * from "./AvatarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af36e7a4",
  null
  
)

export default component.exports